export default "__VITE_PUBLIC_ASSET__699f0160__"